<template>
    <div class="admin-instance-page">
        <div class="nk-block-head nk-block-head-sm">
            <div class="nk-block-between align-items-start">
                <div class="nk-block-head-content admin-instance-list__intro">
                    <div class="admin-instance-list__title-row">
                        <h3 class="nk-block-title page-title mb-0">{{trans('currency.currency')}}</h3>
                    </div>
                    <div class="nk-block-des text-soft" v-if="!currencies.total">
                        <p>{{trans('currency.module_info_description')}}</p>
                    </div>
                </div>
                <div class="nk-fmg-actions flex-shrink-0">
                    <ul class="nk-block-tools g-2 flex-wrap justify-content-end">
                        <li><a href="#" class="btn btn-sm admin-toolbar-btn admin-toolbar-btn--outline" role="button" aria-controls="currency-filter-panel" :aria-expanded="showFilterPanel ? 'true' : 'false'" @click.prevent="showFilterPanel = !showFilterPanel" @keydown.space.prevent="showFilterPanel = !showFilterPanel"><admin-icon name="sliders" aria-hidden="true"></admin-icon> <span>{{trans('general.filter')}}</span></a></li>
                        <li class="nk-block-tools-opt d-sm-block">
                            <button type="button" class="btn btn-sm admin-toolbar-btn admin-toolbar-btn--solid" v-if="hasPermission('create-currency')" v-b-modal.modal-1>
                                <admin-icon name="plus"></admin-icon> {{ trans('general.add_new') }}
                            </button>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <transition name="fade">
            <div id="currency-filter-panel" class="card admin-instance-form-card mb-2" v-if="showFilterPanel">
                <div class="card-body">
                    <div class="admin-instance-card-head">
                        <h4 class="admin-instance-card-head__title">{{trans('general.filter')}}</h4>
                        <p class="admin-instance-card-head__hint">{{ trans('currency.currency') }}</p>
                    </div>
                    <div class="row">
                        <div class="col-6 col-md-4">
                            <div class="form-group">
                                <label for="">{{trans('currency.name')}}</label>
                                <input class="form-control" name="name" v-model="filterCurrencyForm.name">
                            </div>
                        </div>
                        <div class="col-6 col-md-4">
                            <div class="form-group">
                                <label for="">{{trans('general.sort_by')}}</label>
                                <select name="order" class="form-control" v-model="filterCurrencyForm.sort_by">
                                    <option value="name">{{trans('currency.name')}}</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-6 col-md-4">
                            <div class="form-group">
                                <label for="">{{trans('general.order')}}</label>
                                <select name="order" class="form-control" v-model="filterCurrencyForm.order">
                                    <option value="asc">{{trans('general.ascending')}}</option>
                                    <option value="desc">{{trans('general.descending')}}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>

        <div class="admin-list-table-card mt-2" v-if="hasPermission('list-currency') && currencies.total">
            <div class="table-responsive">
                <table class="table admin-data-table admin-data-table--config-list mb-0">
                    <thead>
                        <tr>
                            <sortable-th field="name" :sort-by="filterCurrencyForm.sort_by" :order="filterCurrencyForm.order" @sort="sortList">{{trans('currency.name')}}</sortable-th>
                            <th>{{trans('currency.symbol')}}</th>
                            <th>{{trans('currency.position')}}</th>
                            <th>{{trans('currency.decimal_place')}}</th>
                            <th>{{trans('currency.default')}}</th>
                            <th class="admin-table-actions-cell">{{trans('general.actions')}}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="currency in currencies.data" :key="currency.id">
                            <td v-text="currency.name"></td>
                            <td><code class="admin-instance-meta__code">{{ currency.symbol }}</code></td>
                            <td>{{trans('currency.'+currency.position)}}</td>
                            <td v-text="currency.decimal_place"></td>
                            <td>
                                <span v-if="currency.is_default" class="admin-status-badge admin-status-badge--success" :title="trans('currency.default')">
                                    <admin-icon name="check-circle"></admin-icon>
                                </span>
                                <span v-else class="text-soft">-</span>
                            </td>
                            <td class="admin-table-actions-cell">
                                <table-row-action-dropdown>
                                    <b-dropdown-item-button v-if="hasPermission('edit-currency')" @click="editCurrency(currency)">
                                        <admin-icon name="pencil"></admin-icon> {{ trans('general.edit') }}
                                    </b-dropdown-item-button>
                                    <b-dropdown-item-button
                                        v-if="hasPermission('delete-currency')"
                                        v-confirm="{ok: confirmDelete(currency)}"
                                        class="admin-row-actions__danger"
                                    >
                                        <admin-icon name="trash"></admin-icon> {{ trans('general.delete') }}
                                    </b-dropdown-item-button>
                                </table-row-action-dropdown>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="admin-table-pagination-wrap">
                <pagination-record :page-length.sync="filterCurrencyForm.page_length" :records="currencies" @updateRecords="getCurrencies" @change.native="getCurrencies"></pagination-record>
            </div>
        </div>

        <div class="admin-list-table-card admin-empty-state mt-2" v-if="!currencies.total" role="status">
            <div class="admin-empty-state__inner">
                <div class="admin-empty-state__icon-wrap" aria-hidden="true">
                    <admin-icon name="rupee"></admin-icon>
                </div>
                <h4 class="admin-empty-state__title">{{ trans('currency.module_info_title') }}</h4>
                <p class="admin-empty-state__text">{{ trans('currency.module_info_description') }}</p>
                <button
                    v-if="hasPermission('create-currency')"
                    type="button"
                    class="btn btn-sm admin-toolbar-btn admin-toolbar-btn--solid mt-2"
                    v-b-modal.modal-1
                >
                    <admin-icon name="plus"></admin-icon> {{ trans('general.add_new') }}
                </button>
            </div>
        </div>

        <b-modal id="modal-1" hide-footer centered modal-class="admin-modal-pro" content-class="admin-modal-pro__content">
            <template #modal-title>{{trans('currency.add_new_currency')}}</template>
            <currency-form @completed="getCurrencies"></currency-form>
        </b-modal>
    </div>
</template>

<script>
    import currencyForm from './form'

    import { iconSvg } from '../../icons/admin-icons'

    export default {
        components : { currencyForm },
        data() {
            return {
                currencies: {
                    total: 0,
                    data: []
                },
                filterCurrencyForm: {
                    name: '',
                    sort_by : 'name',
                    order: 'asc',
                    page_length: helper.getConfig('page_length')
                },
                showFilterPanel: false
            };
        },
        mounted(){
            this.getCurrencies();
        },
        methods: {
            hasPermission(permission){
                return helper.hasPermission(permission);
            },
            getCurrencies(page){
                if (typeof page !== 'number') {
                    page = 1;
                }
                this.$bvModal.hide("modal-1");
                let url = helper.getFilterURL(this.filterCurrencyForm);
                axios.get('/api/currency?page=' + page + url)
                    .then(response => response.data)
                    .then(response => this.currencies = response)
                    .catch(error => {
                        helper.showDataErrorMsg(error);
                    });
            },
            editCurrency(currency){
                this.$router.push('/currency/'+currency.id+'/edit');
            },
            confirmDelete(currency){
                return dialog => this.deleteCurrency(currency);
            },
            deleteCurrency(currency){
                axios.delete('/api/currency/'+currency.id)
                    .then(response => response.data)
                    .then(response => {
                        toastr.success(response.message);
                        this.getCurrencies();
                    }).catch(error => {
                        helper.showDataErrorMsg(error);
                    });
            },
            getConfig(config){
                return helper.getConfig(config);
            },
            getDefaultStatus(currency){
                return (currency.is_default) ? '<span class="admin-status-badge admin-status-badge--success" title="'+i18n.currency.default+'">' + iconSvg('check-circle') + '</span>' : '-';
            },
            sortList(field){
                if (this.filterCurrencyForm.sort_by === field) {
                    this.filterCurrencyForm.order = this.filterCurrencyForm.order === 'asc' ? 'desc' : 'asc';
                } else {
                    this.filterCurrencyForm.sort_by = field;
                    this.filterCurrencyForm.order = 'asc';
                }
            }
        },
        watch: {
            filterCurrencyForm: {
                handler(val){
                    this.getCurrencies();
                },
                deep: true
            }
        }
    }
</script>
